<template>
    <transition-group name="fade">
        <div v-if="show" key="0">
            <div class="dg-backdrop" ></div>
            <div class="dg-container">
                <div class="dg-content-cont dg-content-cont--floating confirm-box">
                    <div class="dg-main-content">
                        <div class="dg-view-wrapper">
                            <div class="dg-content-body"><!---->
                                <div class="dg-content">{{textPopup}}</div> <!---->
                            </div>
                            <div class="dg-content-footer"><!---->
                                <button class="btn btn-default dg-pull-left" @click="confirmAction(false)">
                                        <span class="dg-btn-content">
                                            <span class="icon-wrapper" >
                                                <i class="glyphicon glyphicon-exclamation-sign glyphicon--error">
                                                </i>{{translate('Controls.text17')}}
                                            </span>
                                        </span>
                                </button>
                                <button class="btn btn-default dg-pull-right" @click="confirmAction(true)">
                                        <span class="dg-btn-content">
                                            <span class="icon-wrapper">
                                                <i class="glyphicon glyphicon-ok glyphicon--success"> </i>
                                                {{translate('Controls.text16')}}</span>
                                        </span>
                                </button>
                                <div class="dg-clear"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>
</template>

<script>
    export default {
        name: "confirmationCard",
        data: function() {
            return {
                show: false
            }
        },
        props: {
            showPopup: Boolean,
            textPopup: String
        },
        watch: {
            showPopup: function (newVal) {
                this.show = newVal;
            }
        },
        methods: {
            confirmAction: function (value) {
                this.$emit('confirmation', value, null, true);
            }
        }
    }
</script>

<style scoped>
    .dg-container {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5000;
    }
    .dg-backdrop {
        background-color: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 5000;
    }
    .confirm-box {
        font-size: 16px;
        color: #292929;
        box-sizing: border-box;
        width: 100%;
        font-family: inherit;
        position: absolute;
        top: 35%;
        transform: translateY(-70%);
        margin-top: 0;
    }
    .dg-main-content {
        width: 98%;
        /* width: calc(98% - 30px); */
        max-width: 400px;
        padding: 15px;
        border-radius: 5px;
        margin: 25px auto;
        background-color: #ffffff;
    }
    .dg-view-wrapper {
        font-size: 16px;
        color: #292929;
        font-family: inherit;
        box-sizing: border-box;
    }
    .dg-content-body {
        border-bottom: 2px solid #E1E6EA;
        padding-bottom: 15px;
    }
    .dg-content {
        font-size: 16px;
        text-align: center;
        line-height: 1.3em;
    }
    .dg-content-footer{
        position: relative;
        padding: 15px 0 0;
    }
    .glyphicon {
        font-size: 24px;
        margin-right: 9px;
        top: 2px;
    }
    .icon-wrapper {
        position: relative;
        top: -3px;
    }
    .glyphicon--success {
        color: #18ff0c;
    }
    .glyphicon--error {
        color: #d63b3b;
    }
    .dg-pull-right {
        float: right;
    }
    .dg-pull-left {
        float: left;
    }
    .dg-btn-content {
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 700;
        /*color: #0096D9;*/
        box-sizing: border-box;
    }
    .dg-clear {
        height: 2.4em;
        font-size: 16px;
        color: #292929;
        font-family: inherit;
        box-sizing: border-box;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0s
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>
